import { DropDownItem } from '../../../fields/dropdown-item.model';
import { TaxonomyCell } from '../../taxonomies/taxonomy-cell.model';


export class CellCascadingCache {
  allChildFieldIds: number[] = [];

  parentCells: { cell: TaxonomyCell, filter: DropDownItem[]; }[] = [];
  childCells: { cell: TaxonomyCell, filter: DropDownItem[]; }[] = [];

  items: DropDownItem[] = [];
  value: any;

  constructor(
    public cell: TaxonomyCell) {

    if (cell.allItems.length > 0) {
      this.allChildFieldIds = cell.allItems
        .map(c => c.childItems)
        .reduce((a, b) => a.concat(b))
        .map(c => c.fieldId)
        .filter((id, index, arr) => arr.indexOf(id) === index);
    }

    this.value = cell.value;
  }

  reset(): void {
    this.parentCells = [];
    this.childCells = [];
    this.items = [...this.cell.allItems];
  }

  toString(): string {
    return `'${this.cell.field.name}':'${this.value}'->[${this.childCells
      .map(c => `'${c.cell.field.name}':[${c.filter
        .map(f => `'${f.name}'`).join(',')}]`)
      .join(',')}]`;
  }
}
